import { ComponentNotificationBodyProduct } from "./types/task-notification.types";
import { TaskNotificationPriority } from "./TaskNotificationPriority";
import { TaskNotificationStatus } from "./TaskNotificationStatus";
import styles from "./task-notification.module.css";
import { getItemNameIdString } from "./utils/task-notification-body";
import { TaskNotificationSafety } from "./TaskNotificationSafety";

interface TaskNotificationBodyProductProps extends ComponentNotificationBodyProduct {
  read: boolean;
}
export const TaskNotificationBodyProduct = ({
  props: { priority, safety, status, itemInfo },
}: TaskNotificationBodyProductProps) => {
  const itemNameIdString = getItemNameIdString(itemInfo);
  return (
    <div className={styles["task-notification-item-body"] ?? ""}>
      {itemInfo?.imageUrl && (
        <div className={styles["task-notification-item-item-image"] ?? ""}>
          <img
            src={itemInfo.imageUrl}
            alt={itemInfo.name}
            width="44"
            height="44"
          />
        </div>
      )}
      <div className={styles["task-notification-item-body-texts"] ?? ""}>
        {priority && <TaskNotificationPriority />}
        {safety && <TaskNotificationSafety />}
        {!!itemNameIdString && <div>{itemNameIdString}</div>}
      </div>
      {(status === "completed" || status === "closed") && (
        <TaskNotificationStatus status={status} />
      )}
    </div>
  );
};
